import { observable, action, runInAction } from 'mobx'
import remotedev from 'mobx-remotedev'

import { StoreExt } from '@utils/reactExt'

import { insuranceCalculator } from '@services/api'
import { users } from '@services/api'

export class insuranceCalculatorStore extends StoreExt {
    @observable loading = false
    @observable headers = {}
    @observable comparisons = []
    @observable rights = []
    @observable parameters = []
    @observable serviceKey = 0
    @observable header = ''
    @observable index = 0
    @observable name = ''
    @observable fullReport = {}
    @observable newKefelHeser = {}
    @observable insuranceCases = []
    @observable person_id = 0

    @action
    createReport = async (serviceKey, user_id) => {
        this.loading = true
        const newKefelHeser = serviceKey
            ? (await insuranceCalculator.getList({ serviceKey })).data
            : (await insuranceCalculator.createReport({ user_id: user_id })).data
        const data = (await users.getInfo({ user_id: newKefelHeser.person_id || user_id })).data
        runInAction(() => {
            this.newKefelHeser = newKefelHeser.archive || newKefelHeser.insuranceCalculator
            this.loading = false
            this.insuranceCases = data.insuranceCases
            this.person_id = newKefelHeser.person_id || user_id
        })
    }

    @action
    comparePolicies = async (policy1, policy2) => {
        const data = (await insuranceCalculator.comparePolicies({ policy1: policy1.id, policy2: policy2.id })).data
        runInAction(() => {
            this.rights = data.rights
            this.comparisons = { names: [[policy1.name, policy2.name]] }
            this.fullReport = data.parameters
            this.index = 0
            this.headers = {}
            this.header = ''
            this.serviceKey = 0
        })
    }

    @action
    clearFullReport = () => {
        this.fullReport = {}
        this.headers = {}
    }

    @action
    getInsuranceCalculatorParameters = async name => {
        this.name = name
        this.parameters = this.fullReport[name]
    }
}

export default remotedev(new insuranceCalculatorStore())
